import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingAgeFilterEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingAgeFilterEntity
